import { render, staticRenderFns } from "./ProDetailBanner.vue?vue&type=template&id=5ece7acb&scoped=true"
import script from "./ProDetailBanner.vue?vue&type=script&lang=js"
export * from "./ProDetailBanner.vue?vue&type=script&lang=js"
import style0 from "./ProDetailBanner.vue?vue&type=style&index=0&id=5ece7acb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ece7acb",
  null
  
)

export default component.exports